import { notification } from 'antd';

const openNotification = ({ message, description = '', type }) => {
    notification.open({
      type,
      message,
      description,
      duration: 6,
    });
  };

  export default openNotification;